<template>
  <div class="order-config-editor">
    <b-field>
      <b-switch
        v-model="orderEnabled"
        type="is-info">
        Use custom sorting
      </b-switch>
    </b-field>

    <div
      v-if="orderEnabled && inputs"
      class="order-inputs">
      <b-field
        class="input-field"
        label="Order Type"
        :type="childErrors('type', errors).length ? 'is-danger' : ''"
        :message="childErrors('type', errors).map(e => e.msg).join(', ')">
        <SingleSelect
          :value="selectedType"
          :options="orderTypeOptions"
          label="label"
          track-by="key"
          :enable-search="false"
          top-left-label="Order Type"
          @input="handleTypeChange" />
      </b-field>

      <b-field
        v-if="inputs.type === 'DimensionOrder'"
        class="input-field"
        label="Dimension"
        :type="childErrors('dimension', errors).length ? 'is-danger' : ''"
        :message="childErrors('dimension', errors).map(e => e.msg).join(', ')">
        <CompanyDimensionRefSelect v-model="inputs.dimension" />
      </b-field>

      <b-field
        v-if="inputs.type === 'MeasureOrder'"
        class="input-field"
        label="Measure"
        :type="childErrors('measure', errors).length ? 'is-danger' : ''"
        :message="childErrors('measure', errors).map(e => e.msg).join(', ')">
        <CompanyMeasureRefSelect v-model="inputs.measure" />
      </b-field>

      <b-field class="input-field">
        <b-switch
          v-model="ascending"
          type="is-info">
          Ascending
        </b-switch>
      </b-field>

      <b-field
        v-if="inputs.type === 'MeasureOrder'"
        class="input-field"
        label="Time Range (optional)">
        <TimeRangeEditor v-model="inputs.time_range" />
      </b-field>
    </div>
  </div>
</template>

<script>
  import CompanyDimensionRefSelect from '@/components/reports/config/dimensions/CompanyDimensionRefSelect'
  import CompanyMeasureRefSelect from '@/components/reports/config/measures/CompanyMeasureRefSelect'
  import TimeRangeEditor from '@/components/reports/config/modules/common/TimeRangeEditor'
  import SingleSelect from '@/components/ui/singleselect.vue'
  import { childErrors as _childErrors } from '@/components/reports/config/common/validation'

  export default {
    name: 'OrderConfigEditor',
    components: {
      CompanyDimensionRefSelect,
      CompanyMeasureRefSelect,
      TimeRangeEditor,
      SingleSelect,
    },
    props: {
      value: {
        type: Object,
        default: null,
      },
      errors: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        orderTypeOptions: [
          { key: 'DimensionOrder', label: 'by Dimension', },
          { key: 'MeasureOrder', label: 'by Measure', },
        ],
      }
    },
    computed: {
      inputs: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
      orderEnabled: {
        get () {
          return ![null, undefined,].includes(this.inputs)
        },
        set (enabled) {
          if (enabled) {
            this.inputs = {
              type: 'DimensionOrder',
              ascending: true,
              dimension: null,
            }
          } else {
            this.inputs = null
          }
        },
      },
      selectedType () {
        return this.orderTypeOptions.find(o => o.key === this.inputs?.type) || null
      },
      ascending: {
        get () {
          return this.inputs?.ascending !== false
        },
        set (val) {
          if (this.inputs) {
            this.$set(this.inputs, 'ascending', val)
          }
        },
      },
    },
    methods: {
      childErrors: _childErrors,
      handleTypeChange (option) {
        if (!option) return
        if (option.key === 'DimensionOrder') {
          this.inputs = {
            type: 'DimensionOrder',
            ascending: this.inputs?.ascending !== false,
            dimension: null,
          }
        } else if (option.key === 'MeasureOrder') {
          this.inputs = {
            type: 'MeasureOrder',
            ascending: this.inputs?.ascending !== false,
            measure: null,
            time_range: null,
          }
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
.order-inputs {
  margin-top: 20px;
}
</style>
